import { useNavigate } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties'
import { motion } from 'framer-motion';
import { Data, List, portfolio } from 'data/portfolio'

const Third = () => {
  const navigate = useNavigate()
  const goDetail = (id: number) => {
    navigate(`/portfolioDetail?id=${id}`)
  }

  return (
    <div className="flex justify-center items-center bg-white w-full h-screen overflow-hidden">
      <div className='container'>
        <p className='mb-10 font-semibold text-40 text-black'>TINS LAB 포트폴리오</p>
        <Swiper
          slidesPerView={1}
        >
          {portfolio.map((item: Data, index) => (
            <SwiperSlide key={index}>

              <div className="gap-4 grid grid-cols-4 grid-rows-1">
                {item.data.map((items: List, idx: number) => (
                  <motion.div
                    key={idx}
                    transition={{ delay: 0.1 * idx }}
                    onClick={() => goDetail(items.id)}
                    style={{
                      backgroundImage: `url(${items.background})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      width: '100%',
                      height: '30vh',
                    }}
                    className="group flex justify-center items-center rounded-xl w-full font-bold text-white cursor-pointer select-none"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    <div className='flex flex-col justify-center items-center gap-6 bg-[rgba(0,0,0,0.8)] opacity-0 group-hover:opacity-100 rounded-xl w-full h-full transition-opacity duration-300'>
                      {
                        items.logo &&
                        <items.logo />
                      }
                      <div className='flex flex-col items-center'>
                        <p className='text-white'>{items.name}</p>
                        <p className='text-white'>{items.period}</p>
                      </div>
                      <p>{items.description}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}

export default Third
